import { AxiosResponse } from 'axios';
import { IConsultant } from 'models';
import { get } from '../axiosprovider';

const getProfile = async (): Promise<AxiosResponse<IConsultant>> => {
	return await get<IConsultant>('/api/profile');
};

export const profileController = {
	getProfile
};
